import React, { FunctionComponent } from 'react';
import { FacebookIcon, InstagramIcon, PinterestIcon, TwitterIcon, LinkedinIcon } from '../Icons';

type SocialLinkProps = {
  data: {
    externalLink: string;
    type: 'facebook' | 'twitter' | 'instagram' | 'pinterest' | 'linkedin';
    name?: string;
  };
}

const SocialLink: FunctionComponent<SocialLinkProps> = ({ data }) => {
  return (
    <a
      href={data.externalLink}
      target='_blank'
    >
      {data.name && (
        <strong>{data.name}</strong>
      )}
      {data.type === 'facebook' && <FacebookIcon size={32} />}
      {data.type === 'twitter' && <TwitterIcon size={32} />}
      {data.type === 'instagram' && <InstagramIcon size={32} />}
      {data.type === 'pinterest' && <PinterestIcon size={32} />}
      {data.type === 'linkedin' && <LinkedinIcon size={32} />}
    </a>
  );
}

export default SocialLink;
